import ABI from '../assets/abi/ABI.json';
import { Chain } from '../types/IAddresses';

export const NETWORK_ID = 1;
export const INFURA_ID = "7b1a9780e93148b282c6ebdae38ce20f";
export const MAIN_ETHERSCAN_API_KEY = "X5HRH5YDH87X812MS9MYH3HD3BZBSHWYN4"

export const chainInfo: Chain = {
    1: {
        CHAIN:                       "mainnet",
        CHAIN_HEX:                   "0x1",
        CHAIN_NAME:                  "Ethereum Mainnet",
        ETHERSCAN_API:               "https://api.etherscan.io/",
        BLOCK_EXPLORER:              "https://etherscan.io",
        PROVIDER:                    `https://mainnet.infura.io/v3/${INFURA_ID}`,
        AI_UNIVERSE_CONTRACT: {
            ADDRESS:                 "0xd74C4701cC887ab8B6b5302CE4868C4fBC23DE75",
            ABI:                     ABI
        },
    }
}


export const BIG_DECIMAL_18 = 1e18;

export const chain = chainInfo[NETWORK_ID];